// Возвращает классы бейджа по типу периода (как в турнирах).
export function getTypeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-success/20 text-gray-900";
        case "weekly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-warning/30 text-gray-900";
        case "monthly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-brand-accent/30 text-gray-900";
        default:
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-gray-100 text-gray-800";
    }
}
